import { apiMap } from '@qm-activity/common/assets/ts/const';
import { get, post, postForm } from '@common/http';

// 中奖名单公示页面
export const apiPrizeList = () => {
    return get(`${apiMap.apiMa}/marathon/api/v1/winning-list`);
};

export const apiFaceCode = () => {
    return post(`${apiMap.apiMa}/marathon/api/v1/face-code`);
};

// 助力瓜分万元现金主页
export const apiSupportCashHome = (params: Record<string, never> = {}) => {
    return get(`${apiMap.apiMa}/marathon/api/v1/support/cash/home`, params, { noUseJsb: true, });
};

// 申请提现
export const apiWithdrawAll = () => {
    return post(`${apiMap.apiMa}/marathon/api/v1/support/cash/withdraw`);
};
